export default __webpack_public_path__ + "static/media/her1.534bcc1c.png";